import { AxiosError } from 'axios';
import { GET_PARENT_DETAIL_TYPES } from '../../constants/apiUrls';
import { GET_PARENT_DETAIL_TYPES_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface ParentDetailTypesResponse {
  code: string;
  description: string
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ParentDetailTypesResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetParentDetailTypes = ({ onSuccess, onError }: Input = {}) => {
  const getParentDetailTypes = async () => {
    const res = await axiosClient.get<ParentDetailTypesResponse[]>(
      GET_PARENT_DETAIL_TYPES
    );

    return res.data;
  };

  return useCustomQuery(
    [GET_PARENT_DETAIL_TYPES_QUERY_KEY], 
    getParentDetailTypes, 
    {
      onSuccess,
      onError,
    }
  );
};
